// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"j4-z","displaySixCardTiles":"k4-z"};